var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-pc-account-wrapper" },
    [
      _c("create", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showView === "createAccount",
            expression: "showView === 'createAccount'"
          }
        ],
        attrs: { toNext: _vm.toNext }
      }),
      _vm._v(" "),
      _c("record", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showView === "record",
            expression: "showView === 'record'"
          }
        ],
        attrs: { goBack: _vm.goBack, name: _vm.name, pass: _vm.pass }
      }),
      _vm._v(" "),
      _c("process", { staticClass: "process", attrs: { active: _vm.showView } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }